import clsx from 'clsx'
import React from 'react'
import {makeStyles} from 'external/material'
import Box from '@mui/material/Box'
import CreateAssessment from './create-assessment'
import AssessmentFilters from './assessment-filters'
import AssessmentsHead from './assessments-head'
import AssessmentsBody from './assessments-body'
import Fade from '@mui/material/Fade'
import TableContainer from '@mui/material/TableContainer'
import Table from '@mui/material/Table'
import FilterChip from '../components/filter-chip'

const useStyles = makeStyles({
  root: {
    flexGrow: 1,
    width: '100%',
    display: 'flex',
    backgroundColor: '#fff',
    flexDirection: 'column',
  },
  content: {
    display: 'flex',
    flexGrow: 1,
    overflow: 'hidden',
  },
  container: {
    flexGrow: 1,
    overflow: 'auto',
  },
  chips: {
    '&.hasChip': {
      padding: '8px 15px',
      marginTop: 0
    },
    '& .filter-chip': {
      backgroundColor: '#de3434',
      color: '#fff',
      '& .MuiChip-label': {
        padding: '0 20px'
      },
      '& .MuiChip-deleteIcon': {
      }
    }
  },
  filters: {
    display: 'flex',
    padding: '0 15px 8px 15px',
    "& .create-quiz-wrapper": {
      display: "flex",
      marginTop: -9,
      flexDirection: "column",
      justifyContent: "center",
      paddingLeft: 15
    }
  }
})

export default function Assessments({context}) {

  const {translate, updateState} = context
  const classes = useStyles()
  const from = context.link()

  const hasStandardsChip = Object.values(context.quizStandardFilters).some(a => a.length > 0)

  const hasChip = !(!context.query.pattern && !context.query.id && !hasStandardsChip)

  function clearStandardFilters () {
    updateState({
      quizStandardFiltersCalls: {$apply: i => i + 1},
      quizStandardFilters: {expectations: {$set: []}, indicators: {$set: []}, standards:{$set: []}}
    })
  }

  return (
    <Box className={classes.root} >
      <Box className={classes.filters}>
        <AssessmentFilters context={context} />
        <Box className="create-quiz-wrapper">
          <CreateAssessment context={context} />
        </Box>
      </Box>
      <Box className={clsx(classes.chips, {hasChip})}>
        {context.query.pattern && <FilterChip name="pattern" context={context} from={from} />}
        {context.query.id && <FilterChip name="id" context={context} createLabel={() => translate('new-assessment')} from={from} />}
        {hasStandardsChip && <FilterChip name="standards" context={context} createLabel={() => translate('standards-filter-chip')} from={from} onDelete={clearStandardFilters} />}
      </Box>
      <Box className={classes.content}>
        <TableContainer className={classes.container}>
          <Fade in={!context.quizSearch.assessments}>
            <Table className={classes.table}>
              <AssessmentsHead context={context} />
                <AssessmentsBody context={context} />
            </Table>
          </Fade>        
        </TableContainer>
      </Box>
    </Box>
  )
}
